// store.js

import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

// the root, initial state object
const state = {
  user: { email: '' },
  categories: [],
  levels: [],
  topics: [],
  exam: null,
  activeQuestion: null,
  activeSolution: null,
  challenges: [],
  percentageDone: 0,
  results: null
}

// define the possible mutations that can be applied to our state
const mutations = {
  updateEmail (state, email) {
    state.user.email = email
  },
  updateCategories (state, categories) {
    state.categories = categories
  },
  updateLevels (state, levels) {
    state.levels = levels
  },
  updateTopics (state, topics) {
    state.topics = topics
  },
  updateExam (state, exam) {
    state.exam = exam
    if (exam != null) {
      state.activeQuestion = state.exam.questions.data[0]
    }
  },
  updateActiveQuestion (state, activeQuestion) {
    state.activeQuestion = activeQuestion.id
    const exists = state.challenges.find(item => item.question_id === activeQuestion.id)
    if (exists) {
      state.activeSolution =  exists.solution_choice
    } else {
      state.activeSolution = 0
    }
  },
  updateActiveSolution (state, activeSolution) {
    state.activeSolution = activeSolution
  },
  updateChallenges (state, challenges) {
    state.challenges = challenges
  },
  addChallenge (state, challenge) {
    state.challenges.push(challenge)
  },
  removeChallenge (state, challenge) {
    const index = state.challenges.findIndex(item => item.question_id === challenge.question_id)
    if (index > -1)
      state.challenges.splice(index, 1)
  },
  updateResults (state, results) {
    state.results = results
  },
}

const getters = {
  email: (state) => {
    return state.user.email;
  },
  categories: (state) => {
    return state.categories;
  },
  topics: (state) => {
    return state.topics;
  },
  levels: (state) => {
    return state.levels;
  },
  exam: (state) => {
    return state.exam;
  },
  activeQuestion: (state) => {
    if (state.exam && state.exam.questions) {
      const index = state.exam.questions.data.findIndex(item => item.id === state.activeQuestion)
      return state.exam.questions.data[index];
    }
    else
      return null
  },
  activeSolution: (state) => {
    return state.activeSolution;
  },
  challenges: (state) => {
    return state.challenges;
  },
  results: (state) => {
    return state.results;
  }
}

const actions = {
  updateEmail({ commit }, email) {
    commit('updateEmail', email)
  },
  updateCategories({ commit }, categories) {
    commit('updateCategories', categories)
  },
  updateLevels({ commit }, levels) {
    commit('updateLevels', levels)
  },
  updateTopics({ commit }, levels) {
    commit('updateTopics', levels)
  },
  updateExam({ commit }, exam) {
    commit('updateExam', exam)
  },
  updateActiveQuestion({ commit }, activeQuestion) {
    commit('updateActiveQuestion', activeQuestion)
  },
  updateActiveSolution({ commit }, activeSolution) {
    commit('updateActiveSolution', activeSolution)
  },
  updateChallenges({ commit }, challenges) {
    commit('updateChallenges', challenges)
  },
  addChallenge({ commit }, challenge) {
    commit('addChallenge', challenge)
  },
  removeChallenge({ commit }, challenge) {
    commit('removeChallenge', challenge)
  },
  updateResults({ commit }, results) {
    commit('updateResults', results)
  }
}

// create the Vuex instance by combining the state and mutations objects
// then export the Vuex store for use by our components
export const store = new Vuex.Store({
  state,
  mutations,
  getters,
  actions
})



// WEBPACK FOOTER //
// ./src/assets/js/store.js